import React from 'react';
import {decodeHtmlEntity} from "../../../utils/parsing";
import {emailAPI} from "../../../api/email";

const EmailList = () => {
    const {data: emails} = emailAPI.useGetAllQuery()
    return (
        <section className="mb-[15px]">
            <div className="container">
                <div className="mt-4 w-full inline-table">
                    {Array.isArray(emails) && emails.map((email, i) => (
                        <div
                            className="mb-3 bg-gray-100 p-3 rounded"
                            key={i}
                            dangerouslySetInnerHTML={{__html: decodeHtmlEntity(email.text)}}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default EmailList;